import { render } from "./ProjectListing.vue?vue&type=template&id=873b8a38"
import script from "./ProjectListing.vue?vue&type=script&lang=js"
export * from "./ProjectListing.vue?vue&type=script&lang=js"
script.render = render

export default script